import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { JobTypeService } from 'src/app/api/services';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { ModalFormComponent } from 'src/app/shared/component/modal-form/modal-form.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import {
  FormFieldConfig,
  TableAction,
  TableColumn,
} from 'src/app/shared/model/admin';
import { JobType } from 'src/app/shared/model/job-type';
import { ToastService } from 'src/app/shared/service/toast.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-job-type',
  imports: [
    CommonModule,
    LoadingComponent,
    TableGenericComponent,
    ModalFormComponent,
  ],
  templateUrl: './job-type.component.html',
  styles: ``,
})
export class JobTypeComponent {
  mostrarModalAgregar: boolean = false;
  mostrarModalEditar: boolean = false;
  loadingAgregar: boolean = false;
  loadingEditar: boolean = false;
  loadingJobTypes: boolean = false;
  editarSeleccionada?: JobType;

  jobTypes: JobType[] = [];

  formAgregar!: FormGroup;
  formEditar!: FormGroup;

  columns: TableColumn[] = [
    { header: 'Nombre', field: 'description' },
    { header: 'Estado', field: 'state' },
  ];
  actions: TableAction[] = ['edit'];

  fieldsAgregar: FormFieldConfig[] = [
    {
      name: 'description',
      label: 'Nombre',
      placeholder: 'Nombre del tipo de cargo',
    },
  ];
  fieldsEditar: FormFieldConfig[] = [
    {
      name: 'description',
      label: 'Nombre',
      placeholder: 'Nombre del tipo de cargo',
    },
    {
      name: 'state',
      label: 'Estado',
      type: 'select',
      options: [
        { label: 'Activo', value: 'activo' },
        { label: 'Inactivo', value: 'inactivo' },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private jobTypeService: JobTypeService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.cargarJobTypes();
  }

  private initForms(): void {
    this.formAgregar = this.fb.group({
      description: ['', Validators.required],
    });
    this.formEditar = this.fb.group({
      description: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  private cargarJobTypes(): void {
    this.loadingJobTypes = true;
    this.jobTypeService
      .tipoEmpleoGet()
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTYPE.GET_ALL_ERROR),
        finalize(() => (this.loadingJobTypes = false))
      )
      .subscribe((res: any) => {
        this.jobTypes = res.dto?.jobTypes || [];
      });
  }

  openModal(type: 'add' | 'edit', jobType?: JobType): void {
    this.mostrarModalAgregar = false;
    this.mostrarModalEditar = false;
    this.editarSeleccionada = undefined;

    if (type === 'add') {
      this.formAgregar.reset();
      this.mostrarModalAgregar = true;
      return;
    }

    if (type === 'edit' && jobType) {
      this.editarSeleccionada = jobType;
      this.formEditar.setValue({
        name: jobType.description,
        state: jobType.state,
      });
      this.mostrarModalEditar = true;
    }
  }

  crearJobType(): void {
    if (this.formAgregar.invalid) {
      this.formAgregar.markAllAsTouched();
      return;
    }

    this.loadingAgregar = true;
    const { description } = this.formAgregar.value;

    this.jobTypeService
      .tipoEmpleoPost({ body: { description } })
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTYPE.CREATE_ERROR),
        finalize(() => (this.loadingAgregar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.JOBTYPE.CREATE_SUCCESS,
        ]);
        this.cargarJobTypes();
        this.mostrarModalAgregar = false;
      });
  }

  actualizarJobType(): void {
    if (this.formEditar.invalid || !this.editarSeleccionada) {
      this.formEditar.markAllAsTouched();
      return;
    }

    this.loadingEditar = true;
    const { description, state } = this.formEditar.value;
    const idJobType = this.editarSeleccionada.id;

    const nombre$ = this.jobTypeService.tipoEmpleoIdJobTypePatch({
      idJobType,
      body: { description },
    });

    const estado$ = this.jobTypeService.tipoEmpleoEstadoIdJobTypePatch({
      idJobType,
      body: { state },
    });

    forkJoin([nombre$, estado$])
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTYPE.UPDATE_ERROR),
        finalize(() => (this.loadingEditar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.JOBTYPE.UPDATE_SUCCESS,
        ]);
        this.cargarJobTypes();
        this.mostrarModalEditar = false;
      });
  }
}
